import { createSelector } from '@reduxjs/toolkit';

import { selectAuth, selectCurrentUserId } from '@/store/selectors/auth';
import { selectParticipants } from '@/store/selectors/sixDetail';
import { resolveCanCreateSix, resolveIsOwner } from '@/utils/permissions';

export const selectCurrentUserType = createSelector(
  selectAuth,
  (authState) => authState.userType,
);

export const selectCanCreateSix = createSelector(
  selectCurrentUserType,
  (userType) => resolveCanCreateSix(userType),
);

export const selectIsCurrentUserSixOwner = createSelector(
  selectCurrentUserId,
  selectParticipants,
  (currentUserId, participants) => resolveIsOwner(currentUserId, participants?.owners),
);
